const hexToRgba = (hex: string) => {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  const a = hex.slice(7, 9) ? parseInt(hex.slice(7, 9), 16) : 1
  return [r, g, b, a]
}

const isRgb = (color: string) => color.startsWith('rgb')
const isHex = (color: string) => color.startsWith('#')

const getRgbaArray = (rgbaString: string) => {
  const values = rgbaString
    .replace(/rgba?\(/, '')
    .replace(')', '')
    .split(',')
    .map(Number)

  // Ensure alpha is present, default to 1 for rgb() or missing alpha in rgba()
  if (values.length === 3) {
    values.push(1) // Default alpha for rgb()
  } else if (values.length === 4 && (isNaN(values[3]) || values[3] === undefined)) {
    values[3] = 1 // Default alpha for malformed rgba()
  }

  return values
}

const rgbaToHex = (rgbaString: string) => {
  const rgbaArray = getRgbaArray(rgbaString)

  const r = rgbaArray[0].toString(16).padStart(2, '0')
  const g = rgbaArray[1].toString(16).padStart(2, '0')
  const b = rgbaArray[2].toString(16).padStart(2, '0')
  const a = rgbaArray[3]
    ? Math.round(rgbaArray[3] * 255)
        .toString(16)
        .padStart(2, '0')
    : ''

  return `#${r}${g}${b}${a}`
}

export const normalizeColor = (color: string) => {
  if (isRgb(color)) {
    return rgbaToHex(color)
  }

  return color
}

export const parseToObject = (stringColor: string) => {
  const rgbaArray = isHex(stringColor) ? hexToRgba(stringColor) : getRgbaArray(stringColor)

  return {
    r: +rgbaArray[0],
    g: +rgbaArray[1],
    b: +rgbaArray[2],
    a: +rgbaArray[3],
  }
}

interface RGBColor {
  a?: number
  b: number
  g: number
  r: number
}

export const getColorAsString = (color: RGBColor) =>
  `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`

export const isRgba = (style: string) => new RegExp('^rgba?').test(style)

export const changeStringColorOpacity = (stringColor: string, opacity: number) => {
  const colorObj = parseToObject(stringColor)
  colorObj.a = opacity
  return getColorAsString(colorObj)
}

export function isNotTransparent(color: string) {
  const { a } = parseToObject(color)

  return Boolean(a)
}

export function isTransparent(color: string) {
  const { a } = parseToObject(color)

  return !Boolean(a)
}

export function RGBAToHexA(rgba: string) {
  const obj = parseToObject(rgba)
  let r = obj.r.toString(16)
  let g = obj.g.toString(16)
  let b = obj.b.toString(16)
  // let a = Math.round(obj.a * 255).toString(16)

  if (r.length === 1) r = '0' + r
  if (g.length === 1) g = '0' + g
  if (b.length === 1) b = '0' + b
  // if (a.length === 1) a = '0' + a

  // return '#' + r + g + b + a
  return '#' + r + g + b
}
